import React, { useState, useEffect } from "react";
import Pagination from "../../Reusablecomponents/Pagination";
import ExportButton from "../../Reusablecomponents/ExportButton";
import "../../css/others/Table.css";
import { FaEye } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { apiCall } from "../../main/ApiCall";
import ToastPopup from "../../popups/ToastPopup";
import { GlobalChecklistItem, createToastMessage, ToastMessage } from '../../interFaces/interfaces';
const GlobalFunctionTemplates: React.FC = () => {
  const { functionTemplateId } = useParams<{ functionTemplateId: string }>();
  const [data, setData] = useState<GlobalChecklistItem[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const clientId = localStorage.getItem("clientId");
  const navigate = useNavigate();
  const columns = [{ key: "select", label: "Select" }, { key: "serialNumber", label: "S.No" }, { key: "functionCheckListName", label: "Function Checklist Name" }, { key: "functionDescription", label: "Function Description" }, { key: "actions", label: "Actions" }]
  const column = [{ key: "functionCheckListName", label: "Function Checklist Name" }, { key: "functionDescription", label: "Function Description" }]
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await apiCall("get", "/api/function-template/base-templates", null, { clientId, page: currentPage - 1, size: itemsPerPage, });
        const { content = [], totalElements = 0, totalPages = 0 } = response;
        setData(content);
        setTotalElements(totalElements);
        setTotalPages(totalPages);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [functionTemplateId, currentPage, itemsPerPage, clientId]);
  const handleCheckboxChange = (functionTemplateId: number) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = new Set(prevSelectedItems);
      if (updatedSelectedItems.has(functionTemplateId)) {
        updatedSelectedItems.delete(functionTemplateId);
      } else {
        updatedSelectedItems.add(functionTemplateId);
      }
      return updatedSelectedItems;
    });
  };
  const handleSync = async () => {
    try {
      await apiCall("post", `/api/function-template/sync?clientId=${clientId}`);
      setMessage(createToastMessage("Sync Completed successfully!", "success", 3000));
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleAddChecklist = async () => {
    if (selectedItems.size === 0) {
      setMessage(createToastMessage("Please select at least one item.", "warning", 3000));
      return;
    }
    const selectedFunctionTemplateIds = Array.from(selectedItems).filter(Boolean);
    if (selectedFunctionTemplateIds.length === 0) {
      setMessage(createToastMessage("No valid items selected.", "warning", 3000));
      return;
    }
    try {
      await apiCall("patch", "/api/function-template/add-templates", selectedFunctionTemplateIds);
      setMessage(createToastMessage("Function Checklist(s) added successfully!", "success", 3000));
      setTimeout(() => navigate(-1), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const fetchAllDataForExport = async () => {
    try {
      const response = await apiCall("get", "/api/function-template/base-templates", null, { clientId, page: 0, size: totalElements, });
      return response.content || [];
    } catch (error) {
      console.error("Error exporting data:", error);
      return [];
    }
  };
  const handleViewGlobalFunctionTemplateDetails = (row: any) => {
    navigate(`/globalfunctiontemplatedetails/${row.functionTemplateId}`);
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Global Function Checklists</h2>
        <div className="table-title-actions">
          <button className="addchecklist" onClick={handleAddChecklist}>Add Function Checklist</button>
          <button className="sync" onClick={handleSync}>Sync</button>
          <ExportButton data={data} columns={column} fetchAllData={fetchAllDataForExport} fileName="global functions" />
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {columns.map((column) => (<th key={column.key}>{column.label}</th>))}
              </tr>
            </thead>
            <tbody>
              {data?.length > 0 ? (
                data.map((row, index) => (
                  <tr key={row.functionTemplateId}>
                    <td>
                      <input type="checkbox" checked={selectedItems.has(row.functionTemplateId)} onChange={() => handleCheckboxChange(row.functionTemplateId)} />
                    </td>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{row.functionCheckListName || "Empty"}</td>
                    <td>{row.functionDescription || "Empty"}</td>
                    <td><FaEye className="action-button" onClick={() => handleViewGlobalFunctionTemplateDetails(row)} title="View Details" /></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="no-data">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default GlobalFunctionTemplates;